/* tslint:disable */
/* eslint-disable */
/**
 * MedServer
 * API for managing esklepios resources.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Request object for an institute address
 * @export
 * @interface AddressRequest
 */
export interface AddressRequest {
    /**
     * the name of the street in the address
     * @type {string}
     * @memberof AddressRequest
     */
    street?: string;
    /**
     * the locality in the address
     * @type {string}
     * @memberof AddressRequest
     */
    locality?: string;
    /**
     * the postal code in the address
     * @type {string}
     * @memberof AddressRequest
     */
    postalCode?: string;
    /**
     * the code iso of the country
     * @type {string}
     * @memberof AddressRequest
     */
    country?: string;
}

/**
 * Check if a given object implements the AddressRequest interface.
 */
export function instanceOfAddressRequest(value: object): value is AddressRequest {
    return true;
}

export function AddressRequestFromJSON(json: any): AddressRequest {
    return AddressRequestFromJSONTyped(json, false);
}

export function AddressRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): AddressRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'street': json['street'] == null ? undefined : json['street'],
        'locality': json['locality'] == null ? undefined : json['locality'],
        'postalCode': json['postalCode'] == null ? undefined : json['postalCode'],
        'country': json['country'] == null ? undefined : json['country'],
    };
}

export function AddressRequestToJSON(json: any): AddressRequest {
    return AddressRequestToJSONTyped(json, false);
}

export function AddressRequestToJSONTyped(value?: AddressRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'street': value['street'],
        'locality': value['locality'],
        'postalCode': value['postalCode'],
        'country': value['country'],
    };
}

